module.exports = __webpack_public_path__ + "static/img/core.950bb40.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/core.png
// module id = v33N
// module chunks = 12